export function getUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
}

export function getUserId() {
  const user = getUser();
  return user.id;
}

export function getUsername() {
  const user = getUser();
  return user.username;
}

export function getUserRole() {
  const user = getUser();
  return user.role;
}

export function getProfileImageUrl() {
  const user = getUser();
  return user.profileImageUrl;
}